export const VERSION = '10.0.14';
//# sourceMappingURL=pkg-version.js.map